// extracted by mini-css-extract-plugin
export var blockBtn = "main-module--block-btn--c7bc1";
export var cost = "main-module--cost--6f324";
export var costOffer = "main-module--cost-offer--15a00";
export var costPrice = "main-module--cost-price--96bb9";
export var sec = "main-module--sec--bffbc";